import React from 'react';

import IndexPage from '@common/IndexPage';

export default () => <IndexPage language="cs"/>;
